module.exports = __webpack_public_path__ + "static/travel-user-ce224083cfdaa10cf039d158d284d530.png";